import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../../service/data-provider.service';

@Component({
  selector: 'app-gallery-photo',
  templateUrl: './gallery-photo.component.html',
  styleUrls: ['./gallery-photo.component.css']
})
export class GalleryPhotoComponent implements OnInit {
  images: any;
  constructor(public datapro: DataProviderService) {
    this.images = Array(this.datapro.selectedGallery.count).fill(0).map((x, i) => i);
  }



  ngOnInit() {
    window.scrollTo(0,0);
  }

}
